import { render } from "./Radio.vue?vue&type=template&id=40ec6bf6"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jarre\\OneDrive\\Desktop\\MSD\\msd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__